module.exports = __webpack_public_path__ + "static/img/img-3.71cb7c45.png";